import { Recruitment } from 'redux/schemas/models/mentoring-program-recruitments';


// "Who this is for" maps to the recruitment `requirements` field on the backend/flyer.
export const mentorRequirementsDefaultValue = `<ul>
  <li>Open to all with an interest in mentoring others</li>
  <li>No prior mentoring experience required</li>
  <li>Able to commit time on a regular basis</li>
</ul>`;

// "What to expect" maps to the recruitment `expectations` field on the backend/flyer.
export const mentorExpectationsDefaultValue = `<ul>
  <li>Meet 1:1 with your mentee on a regular cadence</li>
  <li>Share your experience and career insights</li>
  <li>Set your own capacity and availability</li>
  <li>Accept or decline mentee connection requests</li>
  <li>Meet 1-2 times per month for 30 minutes</li>
</ul>`;

// "Why join?" maps to the recruitment `benefits` field on the backend/flyer.
export const mentorBenefitsDefaultValue = `<ul>
  <li>Develop your coaching and leadership skills</li>
  <li>Expand your professional network</li>
  <li>Give back and support the growth of others</li>
  <li>Build your reputation as a subject matter expert</li>
</ul>`;

export const menteeRequirementsDefaultValue = `<ul>
  <li>Open to all looking to learn and grow</li>
  <li>Willing to actively engage and take ownership of your development</li>
  <li>Able to commit time on a regular basis</li>
</ul>`;

export const menteeExpectationsDefaultValue = `<ul>
  <li>Meet 1:1 on a regular cadence</li>
  <li>Discuss your goals, challenges, and career aspirations</li>
  <li>Gain insights, advice, and guidance from experienced colleagues</li>
  <li>Take initiative in driving conversations and follow-ups</li>
  <li>Meet 1-2 times per month for 30 minutes</li>
</ul>`;

export const menteeBenefitsDefaultValue = `<ul>
  <li>Accelerate your personal and professional growth</li>
  <li>Gain valuable career insights and perspective</li>
  <li>Build meaningful connections across the organization</li>
  <li>Develop confidence and new skills</li>
  <li>Get support in navigating challenges and opportunities</li>
</ul>`;

// The default registration-page content that is persisted when a recruitment is first
// created, so the flyer renders with the same values the settings form previews.
export const getDefaultRecruitmentValues = (namePrefix: 'mentor' | 'mentee'): Recruitment => (
  namePrefix === 'mentee'
    ? {
      requirements: menteeRequirementsDefaultValue,
      includeRequirements: true,
      expectations: menteeExpectationsDefaultValue,
      includeExpectations: true,
      benefits: menteeBenefitsDefaultValue,
      includeBenefits: true,
    }
    : {
      requirements: mentorRequirementsDefaultValue,
      includeRequirements: true,
      expectations: mentorExpectationsDefaultValue,
      includeExpectations: true,
      benefits: mentorBenefitsDefaultValue,
      includeBenefits: true,
    }
);
